// src/components/Layout.js - Updated
import React from 'react';

const Layout = ({ children }) => {
  const scrollToForm = () => {
    const el = document.getElementById('lead-form');
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <>
      <main className="page-root main-content">{children}</main>
      <button
        className="sticky-mobile-cta"
        onClick={scrollToForm}
        aria-label="Get a free consultation"
      >
        Free Consultation
      </button>
    </>
  );
};

export default Layout;
